export default {
    buttons: {
        close: 'Fechar',
        confirm: 'Confirmar',
        follow: 'Seguir',
        touch: 'Não Exibir Novamente',
    },
}
